import { render, staticRenderFns } from "./BecomePartner.vue?vue&type=template&id=71220da8"
import script from "./BecomePartner.vue?vue&type=script&lang=js"
export * from "./BecomePartner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports